<template>
    <div class="well well-no-shadow prelative pb-7">
        <div class="header">
            <h3 class="mt-0 mb-1">{{ title }}</h3> 
            <h4 class="mt-0 mb-3">{{ subtitle }}</h4> 
        </div>
        <div class="content">
            <div class="content">

                <div v-for="cell in cells" :key="cell.label" class="dinlineb span_4">
                    <span class="block info-label">{{ cell.label }}</span>
                    <span class="block info-value">{{ cell.amount }}</span>
                </div>

            </div>
            <a class="pabsolute bottom-3 right-3 fs-3 link" type="text" :href="link.link"> {{ link.label }} </a>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'subtitle', 'link', 'cells'],
}
</script>
